import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IconArrowRight } from '@tabler/icons-react'

import { setSelectedNode } from '@/reducers/voiceAgents/voiceAgents.redux'
import { getSelectedAgent } from '@/reducers/voiceAgents/voiceAgents.helpers'

import { getHandoffDetails } from '../canvasHelpers'

// Display-only handoff list for sub-agents. Each row shows the peer's title,
// the trigger description, and the underlying tool name. Clicking a row jumps
// the selection to that peer.
const HandoffsTab = ({ node }) => {
  const dispatch = useDispatch()
  const agent = useSelector((state) => getSelectedAgent(state.voiceAgents))

  const targets = useMemo(() => {
    if (!agent || !Array.isArray(node?.peerHandoffs)) {
      return []
    }
    const set = new Set(node.peerHandoffs)
    // Also include peers reachable via primary subagent-transfer edges.
    agent.edges?.forEach((edge) => {
      if (edge.edgeCategory !== 'subagent-transfer') {
        return
      }
      if (edge.from === node.id) {
        set.add(edge.to)
      } else if (edge.to === node.id && edge.bidirectional) {
        set.add(edge.from)
      }
    })
    set.delete(node.id)
    return Array.from(set)
      .map((peerId) => agent.nodes?.find((entry) => entry.id === peerId))
      .filter(Boolean)
  }, [agent, node])

  if (!targets.length) {
    return (
      <div className="voice-agents__drawer-tab" data-testid="drawer-tab-handoffs">
        <p className="voice-agents__drawer-tab-hint">
          This subagent doesn&apos;t hand off to any other agent.
        </p>
      </div>
    )
  }

  return (
    <div className="voice-agents__drawer-tab" data-testid="drawer-tab-handoffs">
      <ul className="voice-agents__handoff-list">
        {targets.map((peer) => {
          const details = getHandoffDetails(node, peer, agent)
          return (
            <li key={peer.id}>
              <button
                type="button"
                className="voice-agents__handoff-row"
                onClick={() => dispatch(setSelectedNode(peer.id))}
                data-testid={`handoff-row-${peer.id}`}
              >
                <div className="voice-agents__handoff-row-body">
                  <div className="voice-agents__handoff-row-title">{peer.title}</div>
                  <div className="voice-agents__handoff-row-trigger">{details.trigger}</div>
                  <div className="voice-agents__handoff-row-tool">
                    <code>{details.tool}</code>
                  </div>
                </div>
                <IconArrowRight size={14} aria-hidden="true" />
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default HandoffsTab
